import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面未找到 - 瓜圈速报',
    description: '你访问的页面不存在或已经下榜，回到瓜圈速报首页查看当前的热度排行与话题榜。',
    keywords: '瓜圈速报,页面未找到',
    path: location.pathname,
  });

  return (
    <section className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden px-4 py-20 text-center">
      <span className="pointer-events-none absolute select-none font-heading text-[8rem] leading-none text-background-200 md:text-[14rem]">
        404
      </span>
      <div className="relative flex flex-col items-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600">
          <i className="ri-map-pin-2-line" />
        </span>
        <h1 className="mt-5 font-heading text-3xl tracking-wide text-foreground-950 md:text-4xl">
          这口瓜走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在，或者链接已经失效。试试回到榜单，看看现在大家都在围观什么。
        </p>
        <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/ranking"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-fire-line" />
            查看热度排行
          </Link>
        </div>
      </div>
    </section>
  );
}